import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls the main content container back to the top on every route change.
 * The app uses an inner Layout with id="main-scroll-container" as the scroll root
 * (html has overflow:hidden), so we target that element directly.
 */
export const ScrollToTop: React.FC = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        const el = document.getElementById("main-scroll-container");
        if (el) {
            el.scrollTo({ top: 0, left: 0, behavior: "auto" });
        } else {
            window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        }
    }, [pathname]);

    return null;
};
